var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.625,
    y: 2.59448,
    width: 22.75,
    height: 22.75,
    rx: 11.375,
    fill: "#1275B1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2526 8.84435C10.2526 9.60367 9.59442 10.2192 8.78254 10.2192C7.97066 10.2192 7.3125 9.60367 7.3125 8.84435C7.3125 8.08503 7.97066 7.46948 8.78254 7.46948C9.59442 7.46948 10.2526 8.08503 10.2526 8.84435Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.51353 11.2298H10.0264V18.8445H7.51353V11.2298Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0722 11.2298H11.5593V18.8445H14.0722C14.0722 18.8445 14.0722 16.4473 14.0722 14.9484C14.0722 14.0488 14.3793 13.1452 15.605 13.1452C16.9902 13.1452 16.9819 14.3225 16.9754 15.2346C16.967 16.4268 16.9871 17.6435 16.9871 18.8445H19.5V14.8256C19.4787 12.2595 18.81 11.077 16.6102 11.077C15.3038 11.077 14.494 11.6702 14.0722 12.2068V11.2298Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.afb6810c6314b894a3ea36e9ca8cea2e.svg";
export { ForwardRef as ReactComponent };